// links object
export const menuLinks = [
  {
    id: 1,
    linkUrl: "/",
    linkName: "Home",
  },
  {
    id: 2,
    linkUrl: "/about",
    linkName: "About us",
  },
  {
    id: 3,
    linkUrl: "/services",
    linkName: "Our services",
  },
  {
    id: 4,
    linkUrl: "/connectus",
    linkName: "Connect us",
  },
];
